module.exports = "## Resize PDF Online\r\n\r\nThis PDF resizer is an online tool. That means no software to install. It will work on your windows, mac, or mobile devices. This tool is 100% free, has no file limits, and does not require registration.\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/PdfResize/resize-pdf-online.md
// module id = 1189
// module chunks = 0